<template>
  <v-container>
    <v-layout row wrap align-top class="text-xs-center">
        <v-flex xs12 class="pa-2">

          <!-- <h2 class="display-1" style="text-decoration: underline;">Sign Up</h2> -->
        </v-flex>
        <v-flex xs12 >
              <iframe src="https://forms.gle/4M9mqXnfeWrAajwU7"
              width="500" height="1600" frameborder="0" marginheight="0" marginwidth="0">Loading…
            </iframe>
        </v-flex>
        <v-flex xs12>
          <v-btn
            large
            color="primary"
            class="mx-0"
            to="/pay"

          >Go to Payments</v-btn>
        </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  export default {
    computed: {
      size () {
        const binding = {}
        if (this.$vuetify.breakpoint.xsOnly) binding.column = true
        return binding
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
select {
appearance: menulist;
}
table {
    margin: auto;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/signupThur.vue